const getShopifyCart = function(callback){
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération du panier.');
    }
    return response.json();
  })
  .then(cart => {
    if (typeof callback === 'function') {
      callback(cart);
    }
  })
  .catch(error => {
    console.error('Erreur getCart:', error);
  });
}

const addShopifyCart = function(variantId, qqt, callback = null){
  fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qqt
      })
    })
    .then(response => response.json()).then(data => {
      if(callback){
        callback(data);
      }else{
        getShopifyCart(function(cart){
          const event = new CustomEvent('flu:cart:item-added', cart);
          document.dispatchEvent(event);
          console.log('Produit ajouté au panier:', cart);
        })
      }
    })
    .catch(error => {
      console.error(error);
    });
}
